import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {Grid} from '@material-ui/core';
import {createForm, formShape} from 'rc-form';
import {isEmpty} from 'lodash/lang';
import {GreatForm} from 'components/common';
import {InputField, SelectField} from 'components/common/rc-fields';
import {createQuiz, updateQuiz} from 'api/quiz';
import {getOptions, levelMap} from 'utils/common';

const levelOptions = getOptions(levelMap);

const QuizForm = ({form, initialValues, onCancel, onSubmitSuccess}) => {
  const isUpdate = !isEmpty(initialValues);
  const {title, level, readingNights} = initialValues || {};
  return (
    <GreatForm
      form={form}
      onCancel={onCancel}
      submitFn={isUpdate ? (payload) => updateQuiz({id: initialValues.id, ...payload}) : createQuiz}
      onSuccess={onSubmitSuccess}
      successMsg={`Quiz has been ${isUpdate ? 'updated' : 'created'} successfully`}
    >
      <InputField
        name="title"
        label="Title"
        initialValue={title || ''}
        rules={[{required: true, message: 'Please enter quiz title'}]}
        form={form}
      />
      <SelectField
        name="level"
        label="Level"
        initialValue={level || ''}
        options={levelOptions}
        rules={[{required: true, message: 'Please select a quiz level'}]}
        form={form}
        autoComplete="off"
        renderValue={(value) => levelMap[value]}
      />
      <InputField
        name="readingNights"
        label="Reading Nights"
        initialValue={readingNights ? readingNights.toString() : ''}
        form={form}
        rules={[{}]}
      />
    </GreatForm>
  );
};

QuizForm.propTypes = {
  form: formShape.isRequired,
  initialValues: PropTypes.object,
  onCancel: PropTypes.func.isRequired,
  onSubmitSuccess: PropTypes.func.isRequired,
};

QuizForm.defaultProps = {
  initialValues: {},
};

export default createForm()(QuizForm);
